'use strict';

var React2 = require('react');
var react = require('@xstate/react');
var xstate = require('xstate');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React2__default = /*#__PURE__*/_interopDefault(React2);

// src/VideoStateProvider/VideoStateProvider.tsx
var VideoStateContext = React2.createContext({
  sendEvent: () => {
  }
});
var VideoStateContext_default = VideoStateContext;

// src/stateMachine/videoStates.ts
var VideoStates = /* @__PURE__ */ ((VideoStates2) => {
  VideoStates2["DISCONNECTED"] = "DISCONNECTED";
  VideoStates2["CONNECTING"] = "CONNECTING";
  VideoStates2["RECONNECTING"] = "RECONNECTING";
  VideoStates2["CONNECTED"] = "CONNECTED";
  VideoStates2["PREVIEW"] = "PREVIEW";
  VideoStates2["SURVEILLANCE"] = "SURVEILLANCE";
  VideoStates2["CALL"] = "CALL";
  VideoStates2["FAILED"] = "FAILED";
  VideoStates2["DISCONNECTING"] = "DISCONNECTING";
  return VideoStates2;
})(VideoStates || {});
var humanReadableState = (state) => {
  switch (state) {
    case "DISCONNECTING" /* DISCONNECTING */:
      return "Call Ending...";
    case "DISCONNECTED" /* DISCONNECTED */:
      return "Call Ended";
    case "CONNECTING" /* CONNECTING */:
      return "Connecting...";
    case "CONNECTED" /* CONNECTED */:
    case "SURVEILLANCE" /* SURVEILLANCE */:
    case "CALL" /* CALL */:
      return "Connected";
    case "PREVIEW" /* PREVIEW */:
      return "Incoming Call";
    case "RECONNECTING" /* RECONNECTING */:
      return "Reconnecting...";
    case "FAILED" /* FAILED */:
      return "Call Failed";
    default:
      return "";
  }
};

// src/stateMachine/guards.ts
var verifyMicPermission = ({ context }) => {
  if (context.callData.deviceData.supportsIntercom) {
    return context.micPermission;
  }
  return true;
};

// src/stateMachine/events.ts
var VideoEvents = /* @__PURE__ */ ((VideoEvents2) => {
  VideoEvents2["ConnectionStart"] = "ConnectionStart";
  VideoEvents2["ConnectionSuccessful"] = "ConnectionSuccessful";
  VideoEvents2["ConnectionFailed"] = "ConnectionFailed";
  VideoEvents2["MaxAttemptsUnsuccessful"] = "MaxAttemptsUnsuccessful";
  VideoEvents2["ShouldReconnect"] = "ShouldReconnect";
  VideoEvents2["MicPermissionEnabled"] = "MicPermissionEnabled";
  VideoEvents2["MicPermissionDisabled"] = "MicPermissionDisabled";
  VideoEvents2["MicEnabled"] = "MicEnabled";
  VideoEvents2["MicDisabled"] = "MicDisabled";
  VideoEvents2["JoinCall"] = "JoinCall";
  VideoEvents2["StartCall"] = "StartCall";
  VideoEvents2["EndCall"] = "EndCall";
  VideoEvents2["IncomingCall"] = "IncomingCall";
  VideoEvents2["VideoDetails"] = "VideoDetails";
  VideoEvents2["StartTeardown"] = "StartTeardown";
  VideoEvents2["TeardownCompleted"] = "TeardownCompleted";
  VideoEvents2["UpdateCallData"] = "UpdateCallData";
  VideoEvents2["WebRTCReconnected"] = "WebRTCReconnected";
  return VideoEvents2;
})(VideoEvents || {});
var ActorEvents = /* @__PURE__ */ ((ActorEvents2) => {
  ActorEvents2["DeviceChanged"] = "DeviceChanged";
  return ActorEvents2;
})(ActorEvents || {});

// src/stateMachine/videoStateMachine.ts
var VIDEO_STATE_MACHINE_ID = "videoState";
var initialContext = {
  micEnabled: false,
  micPermission: false,
  callData: {
    roomData: {},
    deviceData: {},
    history: {}
  }
};
var entered = (value) => console.log("[opvideo-state-machine]", value, "entered");
var exited = (value) => console.log("[opvideo-state-machine]", value, "exited");
var logger = ({ context, event }) => console.log("[opvideo-state-machine] context:", context, "event: ", event);
var videoStateMachine = xstate.setup({
  types: {
    context: {}
  },
  guards: {
    verifyMicPermission
  },
  actions: {
    resetContext: xstate.assign(initialContext),
    micEnabled: xstate.assign({
      micEnabled: true
    }),
    micDisabled: xstate.assign({
      micEnabled: false
    }),
    micPermissionEnabled: xstate.assign({
      micPermission: true
    }),
    micPermissionDisabled: xstate.assign({
      micPermission: false
    }),
    updateCallData: xstate.assign({
      callData: ({ event, context }) => {
        var _a, _b, _c, _d, _e, _f;
        const { roomData, deviceData } = event;
        const { wsUrl, token } = context.callData.roomData;
        const { opvideoDeviceId, opvideoIntercomId } = context.callData.deviceData;
        const callData = {
          roomData: {
            wsUrl: (_a = roomData == null ? void 0 : roomData.wsUrl) != null ? _a : wsUrl,
            token: (_b = roomData == null ? void 0 : roomData.token) != null ? _b : token
          },
          deviceData: {
            opvideoDeviceId: (_c = deviceData == null ? void 0 : deviceData.opvideoDeviceId) != null ? _c : opvideoDeviceId,
            opvideoIntercomId: (_d = deviceData == null ? void 0 : deviceData.opvideoIntercomId) != null ? _d : opvideoIntercomId
          },
          history: {
            opvideoDeviceId: (_e = deviceData == null ? void 0 : deviceData.opvideoDeviceId) != null ? _e : opvideoDeviceId,
            opvideoIntercomId: (_f = deviceData == null ? void 0 : deviceData.opvideoIntercomId) != null ? _f : opvideoIntercomId
          }
        };
        callData.deviceData.supportsIntercom = !!callData.deviceData.opvideoIntercomId && callData.deviceData.opvideoIntercomId > 0;
        return callData;
      }
    }),
    resetCallData: xstate.assign({
      callData: ({ context }) => {
        var _a;
        const callData = {
          roomData: {},
          deviceData: {},
          history: (_a = context.callData.deviceData) != null ? _a : context.callData.history
        };
        return callData;
      }
    }),
    notifyDeviceChanged: xstate.emit(({ event, context }) => ({
      type: "DeviceChanged" /* DeviceChanged */,
      deviceData: context.callData.history,
      nextValue: "deviceData" in event ? event.deviceData : {}
    }))
  }
}).createMachine({
  context: initialContext,
  id: VIDEO_STATE_MACHINE_ID,
  initial: "DISCONNECTED" /* DISCONNECTED */,
  on: {
    ["MicPermissionEnabled" /* MicPermissionEnabled */]: {
      actions: "micPermissionEnabled"
    },
    ["MicPermissionDisabled" /* MicPermissionDisabled */]: {
      actions: "micPermissionDisabled"
    }
  },
  states: {
    ["DISCONNECTED" /* DISCONNECTED */]: {
      entry: [logger, () => entered("DISCONNECTED" /* DISCONNECTED */)],
      exit: [logger, () => exited("DISCONNECTED" /* DISCONNECTED */)],
      on: {
        ["UpdateCallData" /* UpdateCallData */]: {
          actions: ["notifyDeviceChanged", "updateCallData"]
        },
        ["ConnectionStart" /* ConnectionStart */]: {
          target: "CONNECTING" /* CONNECTING */,
          actions: ["notifyDeviceChanged", "updateCallData"]
        }
      }
    },
    ["RECONNECTING" /* RECONNECTING */]: {
      entry: [logger, () => entered("RECONNECTING" /* RECONNECTING */)],
      exit: [logger, () => exited("RECONNECTING" /* RECONNECTING */)],
      on: {
        ["UpdateCallData" /* UpdateCallData */]: {
          actions: ["notifyDeviceChanged", "updateCallData"]
        },
        ["ConnectionFailed" /* ConnectionFailed */]: {
          target: "FAILED" /* FAILED */,
          actions: ["notifyDeviceChanged", "updateCallData"]
        },
        ["WebRTCReconnected" /* WebRTCReconnected */]: { target: "CONNECTED" /* CONNECTED */ }
      }
    },
    ["CONNECTING" /* CONNECTING */]: {
      entry: [logger, () => entered("CONNECTING" /* CONNECTING */)],
      exit: [logger, () => exited("CONNECTING" /* CONNECTING */)],
      on: {
        ["ConnectionSuccessful" /* ConnectionSuccessful */]: { target: "CONNECTED" /* CONNECTED */ },
        ["ConnectionFailed" /* ConnectionFailed */]: { target: "FAILED" /* FAILED */ },
        ["MaxAttemptsUnsuccessful" /* MaxAttemptsUnsuccessful */]: { target: "FAILED" /* FAILED */ }
      }
    },
    ["CONNECTED" /* CONNECTED */]: {
      entry: [logger, () => entered("CONNECTED" /* CONNECTED */)],
      exit: [logger, () => exited("CONNECTED" /* CONNECTED */)],
      on: {
        ["VideoDetails" /* VideoDetails */]: {
          target: "SURVEILLANCE" /* SURVEILLANCE */
        },
        ["IncomingCall" /* IncomingCall */]: {
          target: "PREVIEW" /* PREVIEW */,
          actions: ["notifyDeviceChanged", "updateCallData"]
        },
        ["EndCall" /* EndCall */]: {
          target: "DISCONNECTING" /* DISCONNECTING */
        }
      }
    },
    ["PREVIEW" /* PREVIEW */]: {
      entry: [logger, () => entered("PREVIEW" /* PREVIEW */)],
      exit: [logger, () => exited("PREVIEW" /* PREVIEW */)],
      on: {
        ["JoinCall" /* JoinCall */]: {
          target: "CALL" /* CALL */
        },
        ["EndCall" /* EndCall */]: {
          target: "DISCONNECTING" /* DISCONNECTING */
        },
        ["ShouldReconnect" /* ShouldReconnect */]: {
          target: "RECONNECTING" /* RECONNECTING */
        },
        ["ConnectionFailed" /* ConnectionFailed */]: { target: "FAILED" /* FAILED */ }
      }
    },
    ["SURVEILLANCE" /* SURVEILLANCE */]: {
      entry: [logger, () => entered("SURVEILLANCE" /* SURVEILLANCE */)],
      exit: [logger, () => exited("SURVEILLANCE" /* SURVEILLANCE */)],
      on: {
        ["IncomingCall" /* IncomingCall */]: {
          target: "PREVIEW" /* PREVIEW */,
          actions: ["notifyDeviceChanged", "updateCallData"]
        },
        ["StartCall" /* StartCall */]: {
          target: "CALL" /* CALL */
        },
        ["EndCall" /* EndCall */]: {
          target: "DISCONNECTING" /* DISCONNECTING */
        },
        ["ShouldReconnect" /* ShouldReconnect */]: {
          target: "RECONNECTING" /* RECONNECTING */
        },
        ["ConnectionFailed" /* ConnectionFailed */]: { target: "FAILED" /* FAILED */ }
      }
    },
    ["CALL" /* CALL */]: {
      entry: [
        xstate.raise({ type: "MicEnabled" /* MicEnabled */ }),
        logger,
        () => entered("CALL" /* CALL */)
      ],
      exit: [logger, () => exited("CALL" /* CALL */)],
      on: {
        ["MicEnabled" /* MicEnabled */]: {
          guard: "verifyMicPermission",
          actions: "micEnabled"
        },
        ["MicDisabled" /* MicDisabled */]: {
          actions: "micDisabled"
        },
        ["MicPermissionDisabled" /* MicPermissionDisabled */]: {
          target: "SURVEILLANCE" /* SURVEILLANCE */,
          actions: ["micDisabled"]
        },
        ["VideoDetails" /* VideoDetails */]: {
          target: "SURVEILLANCE" /* SURVEILLANCE */,
          actions: "micDisabled"
        },
        ["EndCall" /* EndCall */]: {
          target: "DISCONNECTING" /* DISCONNECTING */,
          actions: "micDisabled"
        },
        ["ShouldReconnect" /* ShouldReconnect */]: {
          target: "RECONNECTING" /* RECONNECTING */,
          actions: ["micDisabled", "resetCallData"]
        },
        ["ConnectionFailed" /* ConnectionFailed */]: { target: "FAILED" /* FAILED */ }
      }
    },
    ["FAILED" /* FAILED */]: {
      entry: [logger, () => entered("FAILED" /* FAILED */)],
      exit: [logger, () => exited("FAILED" /* FAILED */)],
      on: {
        ["StartTeardown" /* StartTeardown */]: { target: "DISCONNECTING" /* DISCONNECTING */ }
      }
    },
    ["DISCONNECTING" /* DISCONNECTING */]: {
      entry: [logger, () => entered("DISCONNECTING" /* DISCONNECTING */)],
      exit: [logger, () => exited("DISCONNECTING" /* DISCONNECTING */)],
      on: {
        ["TeardownCompleted" /* TeardownCompleted */]: {
          target: "DISCONNECTED" /* DISCONNECTED */,
          actions: "resetContext"
        }
      }
    }
  }
});
var videoStateMachine_default = videoStateMachine;

// src/stateMachine/index.ts
var stateMachine_default = videoStateMachine_default;

// src/VideoStateProvider/VideoStateProvider.tsx
var VideoStateProvider = (props) => {
  const { children } = props;
  const [state, send, actor] = react.useMachine(stateMachine_default);
  const value = React2.useMemo(
    () => ({
      sendEvent: send,
      videoState: state,
      machineActor: actor
    }),
    [state, send, actor]
  );
  return /* @__PURE__ */ React2__default.default.createElement(VideoStateContext_default.Provider, { value }, children);
};
var VideoStateProvider_default = VideoStateProvider;

// src/VideoStateProvider/index.tsx
var VideoStateProvider_default2 = VideoStateProvider_default;
var useVideoState_default = () => {
  const context = React2.useContext(VideoStateContext_default);
  if (!context) {
    throw new Error("useVideoState should be used under VideoStateProvider");
  }
  return context;
};

exports.ActorEvents = ActorEvents;
exports.VideoEvents = VideoEvents;
exports.VideoStateProvider = VideoStateProvider_default2;
exports.VideoStates = VideoStates;
exports.humanReadableState = humanReadableState;
exports.useVideoState = useVideoState_default;
exports.videoStateMachine = stateMachine_default;
